import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const ALL_POLL_LIST = 'ALL_POLL_LIST';
export const POLL_ACTION_MODAL = 'POLL_ACTION_MODAL';

export function fetchAllPolls(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})AND(isarchived=0)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions?include_count=true&related=poll_results_by_pollid&filter=(${filter})&order=displayorder%20ASC%2C%20createdon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // console.log('data:- ', data);
        dispatch({
          type: ALL_POLL_LIST,
          payload: { resource: data.resource, count: data.meta.count }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function pollModal(obj) {
  return dispatch => {
    dispatch({ type: POLL_ACTION_MODAL, payload: obj });
  };
}

export function savePollAns(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_results`;
  var body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        dispatch(fetchAllPolls(session));
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}
